import type { ICheckoutContext } from '@/types/context';

export const getLogInfoData = (context: ICheckoutContext): Record<string, unknown> => {
  return {
    templateType: context.template.type,
    paymentMethodSelected: context.paymentMethodSelected,
    paymentMethodsAvailable: context.paymentMethodsAvailable,
    paymentMethodsSettings: context.paymentMethodsSettings,
    publisher: context.publisher,
    pricing: context.pricing,
    offer: context.offer,
    totalPrice: context.totalPrice,
    customer: context.customer,
  };
};
